import React from "react";
// Action Creators
import { ActionCreator } from "@ms/planner-actioncreators/lib/local/actioncreators/ActionCreator";
import { useActionCreators } from "@ms/planner-container-controls/lib/local/hooks/useActionCreators";
// Stores:
import { Store, useStores } from "@ms/planner-container-controls/lib/local/hooks/useStores";
import { isStateFailure } from "@ms/planner-stores/lib/local/utilities/StatusUtilities";
// Constants
import { multiPageDialogHostId } from "@ms/uno-constants/lib/local/DialogConstants";
import { SubRouteType } from "@ms/uno-constants/lib/local/RoutingConstants";
// Controls
import { Toaster, useAnnounce, useToastController } from "@fluentui/react-components";
import { LandmarkWrapper } from "@ms/planner-generic-controls/lib/local/landmark/LandmarkWrapper";
// Styles
import { useGlobalScrollbarStyles, usePlannerShellLayoutStyles, useTooltipGlobalStyles } from "./PlannerShellLayout.styles";
// Utilities
import { setGlobalToastDispatcher } from "@ms/planner-presentational-controls/lib/local/utilities/ToastUtilities";
import { extractPlanRoutingDetailsFromSubRoute } from "@ms/uno-routing";
import { getUnoMainContentId } from "@ms/uno-utilities/lib/local/IdUtilities";
import throttle from "lodash/throttle";
/**
 * Planner shell layout
 */ export function PlannerShellLayout(props) {
    const mainContentId = getUnoMainContentId(props.appInstanceId);
    const styles = usePlannerShellLayoutStyles();
    useGlobalScrollbarStyles();
    useTooltipGlobalStyles();
    const [viewTransformsAc] = useActionCreators([
        ActionCreator.ViewTransforms
    ]);
    const [planStore, routeStore] = useStores([
        Store.Plan,
        Store.Route
    ]);
    // Set up the global toast dispatcher
    const toasterId = "PlannerToaster";
    const { dispatchToast } = useToastController(toasterId);
    setGlobalToastDispatcher(dispatchToast);
    const { announce } = useAnnounce();
    /** The number of ms to throttle invocations for resize handler */ const throttleWaitTime = 100;
    const throttledWindowResizeHandler = React.useRef(throttle(()=>handleResize(), throttleWaitTime)).current;
    const handleResize = ()=>{
        viewTransformsAc.setScreenWidth(window.innerWidth);
    };
    React.useEffect(()=>{
        window.addEventListener("resize", throttledWindowResizeHandler);
        return ()=>{
            window.removeEventListener("resize", throttledWindowResizeHandler);
        };
    }, [
        throttledWindowResizeHandler
    ]);
    // Check if we need to hide the notification bar for plan pages based on the current plan store state
    const subRouteType = routeStore.getCurrentSubRouteType();
    const planRoutingDetails = extractPlanRoutingDetailsFromSubRoute(routeStore.getCurrentSubRoute(), subRouteType);
    const currentPlanStoreReadResult = planRoutingDetails ? planStore.getPlan(planRoutingDetails.planId) : null;
    const storeState = currentPlanStoreReadResult?.status.state;
    let hideNotificationBar = false;
    if ((subRouteType === SubRouteType.BasicPlan || subRouteType === SubRouteType.PremiumPlan) && storeState != null && isStateFailure(storeState)) {
        hideNotificationBar = true;
    }
    const renderAppContent = ()=>{
        return /*#__PURE__*/ React.createElement("div", {
            className: styles.appContent
        }, props.leftNav, /*#__PURE__*/ React.createElement("div", {
            id: multiPageDialogHostId,
            className: styles.mainContentContainer
        }, props.newsBar, !hideNotificationBar && props.notificationBar, props.primaryView), props.taskEditorPanel, props.copilotPanel);
    };
    return /*#__PURE__*/ React.createElement(LandmarkWrapper, null, /*#__PURE__*/ React.createElement("div", {
        className: styles.root,
        id: mainContentId
    }, props.suiteNav, renderAppContent(), props.modalLayers, props.devTools, props.campaignCallout, /*#__PURE__*/ React.createElement(Toaster, {
        toasterId: toasterId,
        announce: (message)=>announce(message)
    })));
}
